export default __webpack_public_path__ + "static/media/brandfolder-preview.903cbc44.gif";